import Vue from 'vue';
import { mapActions } from 'vuex';
import store from 'store';
import validate from 'mixins/validate';
import VueScrollTo from 'vue-scrollto';

Vue.use(VueScrollTo);
Vue.config.silent = true;

/**
 * Here, we take all of the independent
 * Vuex modules laid out in the store
 * subdirectories and create a single Vuex
 * store that includes all of them.
 */
export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
      'product-hero': () => import('../product-hero/product-hero.vue'),
      'product-video': () => import('../product-video/product-video.vue'),
      'product-coupon-markup': () =>
        import('../product-coupon-markup/product-coupon-markup.vue'),
    },
    el,
    store,
    name: 'Product',
    mounted() {
      const pID = this.$el.dataset.productId;
      const pFamily = this.$el.dataset.productFamily;

      if (pID && pFamily) {
        let rvProductList = window.localStorage.getItem(
          'recentViewedProductList',
        );
        rvProductList = rvProductList ? JSON.parse(rvProductList) : [];
        rvProductList = rvProductList.filter((prod) => {
          return prod.family !== pFamily;
        });
        const variant = new URLSearchParams(location.search).get('variant');
        rvProductList = rvProductList.slice(-9, rvProductList.length);
        rvProductList.push({
          family: pFamily,
          handle: pID,
          variant,
        });

        window.localStorage.setItem(
          'recentViewedProductList',
          JSON.stringify(rvProductList),
        );
      }

      this.handleVariantChange(pFamily);
    },
    methods: {
      ...mapActions('global', ['openModal']),
      handleVariantChange(family) {
        window.addEventListener('variant:change', (e) => {
          if (family) {
            let rvProductList = window.localStorage.getItem(
              'recentViewedProductList',
            );
            rvProductList = rvProductList ? JSON.parse(rvProductList) : [];
            rvProductList = rvProductList.filter((prod) => {
              return prod.family !== family;
            });

            rvProductList = rvProductList.slice(-9, rvProductList.length);
            const variant = new URLSearchParams(location.search).get('variant');
            rvProductList.push({
              family,
              handle: e.detail.handle,
              variant,
            });

            window.localStorage.setItem(
              'recentViewedProductList',
              JSON.stringify(rvProductList),
            );
          }
        });
      },
    },
    mixins: [validate],
    beforeDestroy() {
      window.removeEventListener('variant:change');
    },
  });
